angular.module('contactModule').component('contact', {
	templateUrl: 'contact/contact.html',
	bindings: {
		buttonText: '@',
		user: '<',
		companyPhone: '@',
		startingDate: '@',
		nbDays: '@',
		popupName: '@',
		rpc: '@',
		headerVersion: '@',
		listingRpc: '@',
		collectionId: '<',  // used for buildings/listings collection
		items: '<', // used for buildings/listings collection
		type: '@',
		page: '@',
		version: '@',
		target: '<',
		popup: '@',
		source: '@',
		photoPlaceholder: '@',
		trackAction: '@',
		trackActionQuestion: '@',
		trackActionPhone: '@',
		trackActionPhoneCall: '@',
		trackLabelLoad: '@',
		trackLabelStart: '@',
		trackLabelFinish: '@',
		trackLabelRegistered: "@",
		trackLabelSignedUpSM: "@",
		trackLabelClosed: "@",
		trackCategory: '@',
		displayTitle: '<',
		displayDates: '<',
		displayCallUs: '<',
		gtag: '@',
		isMobile: '@',
		customTitle: '@',
		// contactSubtitle: '@',
		subTitle: '@',
		subTitleExtra: '@',
		subTitleNoUnits: '@',
		address: '@',
		multisteps: '@',
		defaultMessage: '@',
		placeholderMessage: '@',
		messageLabel: '@',
		rpcAgents: '@',
		rpcSmartmatch: '@',
		rpcRegisterContact: "@", //rpc-register-contact-submit
		customClass: '@',
		pageLabel: '@',
		objectId: '@',
		id: '@',
		buildingToken: '@',
		listingToken: '@',
		mode: '@',
		position: '@',
		skipRentQuestions: '@',
		openhouse: '<',
		token: "@",
		onFormSubmitted: '&',
		listingHiddenObjWrapper: '<',
		listingExtra: '<',
		buildingHiddenObjWrapper: '<',
		buildingExtra: '<',
		openhouses: '<'
	},
	controller: ['$timeout', '$window', '$cookies', 'PubSub', '$element', 'crResourcesService', function ($timeout, $window, $cookies, PubSub, $element, crResourcesService) {
		var ctrl = this;
		this.errorMessages = {
			// required: 'This field is required.',
			requiredName: 'Please enter your name',
			requiredPhone: 'Please include your phone number',
			requiredEmail: 'Please include your email address',
			email: 'Invalid Email.',
			emailExist: 'This email already exists.',
			phoneExist: 'This phone already exists.',
			// phoneFormat: 'This phone number is not valid.',
			phoneFormat: 'Please verify if the number you provided is correct',
			phoneShort: 'This phone is too short (less than 6 characters).',
			minlength: 'Password can\'t be shorter than 6 characters.',
			maxlength: 'Password can\'t be longer than 64 characters.',
			notFullname: 'Please enter a full name.',
			buyerRenter: 'Buying or renting?',
			recaptcha: "Recaptcha verification failed. Please try again.",
			listings: 'Please select at least one apartment',
			generic: 'Something went wrong. Please contact us for further assistance or try again later. (212) 755-5544.'
		};

		this.$onInit = () => {
			this.isM = this.isMobile === '1';
			this.formData = {
				isLoading: false
			};

			this.usrRegisterStatus = false;
			this.usrRegisterMessage = "";
			this.autoUsrToken = null;
			this.smartMatchToken = null;

			this.steps = {
				STEP1: 1,
				STEP2: 2,
				STEPBEDS: 4,
				STEPNOUNITS: 5,
				MOREINFORMATION: 3,
				RELOADCOUNTER: 9,
				current: 1
			};

			if (this.mode === 'basic-question' || this.mode === 'basic-contact' || this.mode === 'ask-question') {
				this.steps.current = this.steps.MOREINFORMATION;
			}

			this.tabindex = {
				name: 1,
				email: 2,
				phone: 3,
				message: 4
			};

			if (this.startingDate && this.nbDays) {
				this.formData.dates = [];
				for (let i = 0; i < this.nbDays; i++) {
					let nextDate = moment(this.startingDate).add(i, 'days');
					let dayLabel = nextDate.format('ddd');
					let dayNumber = nextDate.format('DD');
					let month = nextDate.format('MMM');
					let dateFormatted = nextDate.format('YYYY-MM-DD');
					let dayLabelB = nextDate.format("dddd, MMM DD");
					this.formData.dates.push({
						selected: (i === 0 ? true : false),
						dayLabel,
						dayNumber,
						month,
						dateFormatted,
						dayLabelB
					});
				}
				this.user.selectedDate = this.formData.dates.find((d) => {
					return d.selected;
				});
			}

			// check if multisteps
			this.isMultisteps = true;

			if (this.target && (this.type === 'listing-sale' || this.type === 'building-condo' || this.type === 'building-predev')) {
				if (this.type === 'listing-sale' || this.type === 'building-condo') {
					if (this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK') {
						this.isMultisteps = false;
					}
				}
				if (this.type === 'building-predev') {
					this.isMultisteps = false;
				}
			}

			if (this.user.isBroker) {
				this.isMultisteps = false;
			}

			if (this.mode === 'basic-question' || this.popup === 'basic-contact' || this.popup === 'openhouse') {
				this.isMultisteps = false;
			}

			// auto submit (on mobile, user is a broker with assigned agent)
			// if (this.isM && this.type === 'building-predev' && this.target && (this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK')) {
			// 	this.submitForm();
			// }

			// track load(desktop) or start(mobile)
			crTrackerQueue.track({
				category: this.trackCategory,
				action: this.mode === 'ask-question' ? this.trackActionQuestion : this.trackAction,
				label: this.trackLabelLoad ? this.trackLabelLoad : this.trackLabelStart
			});

			this.trackLabelDefault = "Contact Start";

			// on desktop show top nav contact button
			let contactTopNav = document.querySelector('.button-contact-top');
			if (contactTopNav) {
				contactTopNav.classList.remove('none');
			}

			if (this.popupName === 'popup-in-entry' && !this.user.smartmatch && !this.user.isGuest) {
				this.autoclose = false;
			} else {
				this.autoclose = true;
			}
		};

		this.getSelectedItems = () => {
			let selectedItems = [];
			if (this.items && Object.entries(this.items).length > 0) {
				Object.entries(this.items).forEach(entry => {
					let entries = entry[1].filter(item => item.selected);
					selectedItems = [...selectedItems, ...entries];
				});
			}
			return selectedItems;
		};

		this.submitForm = function (form) {
			this.formData.isLoading = true;
			window.crRecaptcha.execute(() => {
				this.submitFormLogic(form);
			});
		};

		this.submitStep1 = function (form, successCallback) {
			this.formData.isLoading = true;
			if (form) {
				form.globalErrors = [];
			}

			if (this.trackLabelLoad) { // twisted logic: if there is no trackLabelLoad, then trackLabelStart was triggered previously, hence it's not triggered here
				crTrackerQueue.track({
					category: this.trackCategory,
					action: this.mode === "ask-question" ? this.trackActionQuestion : this.trackAction,
					label: this.trackLabelStart
				});
			}

			window.crRecaptcha.execute(() => {
				var crDataPromise = crResourcesService.post(this.rpc, this.createData());
				crDataPromise.then((data) => {
					if (data["RPCFormReusableContact_FORMSUMMARY"][0].status && typeof (successCallback) === "function") {
						window.crRecaptcha.setSuccessState(true);

						if (typeof (crGtag) !== 'undefined' && this.gtag) {
							crGtag.track(this.gtag);
						}

						if (typeof (crGtag) !== 'undefined' && data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
							crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
						}

						successCallback();
					} else {
						window.crRecaptcha.setSuccessState(false);
						if (form) {
							if (data["RPCFormReusableContact_recaptcha"]) {
								form.globalErrors.push(this.errorMessages.recaptcha);
							} else {
								form.globalErrors.push(this.errorMessages.generic);
							}
						}
					}
				}).finally(() => {
					this.formData.isLoading = false;
				});
			});
		};

		this.submitCnt = 0;
		this.submitFormLogic = function ($form) {
			var url = this.rpc;
			var _postData = this.createData();
			var form = $form;

			this.emptyMessage = false;
			if (!!form.showMessage && !_postData.msg) {
				this.emptyMessage = true;
			}

			var crDataPromise = crResourcesService.post(url, _postData);

			// this.formData.isLoading = true;
			if (form) {
				form.globalErrors = [];
			}

			crDataPromise.then((data) => {
				if (data['RPCFormReusableContact_FORMSUMMARY'][0].status) {
					window.crRecaptcha.setSuccessState(true);

					// disable exit popups
					var now = new Date(),
						exp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5); // set the expiration to 5 days ahead
					$cookies.put('exitPopupShown', 'true', { expires: exp });

					this.formData.isLoading = false;
					this.successMessage = data['RPCFormReusableContact_FORMSUMMARY'][0].message;

					this.isSuccessMessage = true;

					this.emptyBuyerRenter = false;
					if (!!form.showBuyingRentingCheckboxes && !_postData.buyerRenter) {
						this.emptyBuyerRenter = true;
					}

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken !== "undefined") {
						this.autoUsrToken = data["RPCFormReusableContact_FORMSUMMARY"][0].autoUsrToken;
					} else {
						this.autoUsrToken = null;
					}

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken !== "undefined") {
						this.smartMatchToken = data["RPCFormReusableContact_FORMSUMMARY"][0].smartMatchToken;
					} else {
						this.smartMatchToken = null;
					}

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].token !== "undefined" && (this.steps.current === this.steps.STEP2 && this.isMultisteps || !this.isMultisteps)) {
						if (this.emptyMessage == false && this.emptyBuyerRenter == false) {
							this.token = data["RPCFormReusableContact_FORMSUMMARY"][0].token;
							PubSub.publish("contact-form-propagate-token", this.token);
						}
					}

					// track gtag
					if (typeof (crGtag) !== 'undefined' && this.gtag) {
						crGtag.track(this.gtag);
					}

					this.isClosing = this.autoclose;

					// CITY-2925 - Do not auto close if there is an opportunity to register
					if (this.autoUsrToken || this.smartMatchToken) {
						this.isClosing = false;
					}

					this.submitCnt++;

					// track Contact Finish
					var category = this.trackCategory || $window.pageType;
					if (this.submitCnt == 1 && category && this.trackAction) {
						crTrackerQueue.track({
							category: this.trackCategory,
							action: this.steps.current === this.steps.MOREINFORMATION ? this.trackActionQuestion : this.trackAction,
							label: this.trackLabelFinish
						});
					}

					if (this.emptyMessage == false && this.emptyBuyerRenter == false || this.submitCnt >= 3) {
						this.updatePopup();
						$timeout(() => {
							if (this.isClosing) {
								if (this.trackLabelClosed) {
									crTrackerQueue.track({
										category: this.trackCategory,
										action: this.trackAction,
										label: this.trackLabelClosed
									});
								}

								this.closeTheForm();
								this.isClosing = false;
							}
						}, 7000);
					} else {
						this.hideSuccessMessage();
					}

					if (typeof (crGtag) !== 'undefined' && data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}
				} else {
					window.crRecaptcha.setSuccessState(false);

					if (form) {
						let specificError = false;
						if (data["RPCFormReusableContact_email"]) {
							var error = data["RPCFormReusableContact_email"];
							if (error[0].indexOf("valid") > 0) {
								form.email.$setValidity("pattern", false);
							} else {
								// may be another/generic message, but for now it's the same
								form.email.$setValidity("pattern", false);
							}
							specificError = true;
						}

						if (data["RPCFormReusableContact_dayphone"]) {
							var error = data["RPCFormReusableContact_dayphone"];
							if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0) {
								form.phone.$setValidity("phoneExist", false);
							} else if (error[0].indexOf("too short") > 0) { // phone too short
								form.phone.$setValidity("phoneShort", false);
							} else { // twilio phone error
								form.phone.$setValidity("pattern", false);
							}
							specificError = true;
						}

						if (data["RPCFormReusableContact_recaptcha"]) {
							form.globalErrors.push(this.errorMessages.recaptcha);
						} else if (!specificError) {
							form.globalErrors.push(this.errorMessages.generic);
						}
					}
					this.formData.isLoading = false;
				}
			}).finally(() => {
				this.formData.isLoading = false;

				// remove the user selected listings if we have some
				delete this.user.listings;
			});
		};

		this.subscribeSmartMatch = () => {
			var data = {
				smartMatchToken: this.smartMatchToken
			};
			var crDataPromise = crResourcesService.post(this.rpcSmartmatch, data);
			crDataPromise.then((data) => {
				if (this.trackLabelSignedUpSM) {
					crTrackerQueue.track({
						category: this.trackCategory,
						action: this.trackAction,
						label: this.trackLabelSignedUpSM
					});
				}
			}).finally(() => {
				this.closeTour();
			});
		};

		this.subscribeSmartMatch2 = () => {
			this.formData.isLoading = true;
			this.usrRegisterStatus = true;
			this.usrRegisterMessage = "";

			var input = {
				smartMatchToken: this.smartMatchToken
			};

			var crDataPromise = crResourcesService.post(this.rpcSmartmatch, input);
			crDataPromise.then((data) => {
				if (this.trackLabelSignedUpSM) {
					crTrackerQueue.track({
						category: this.trackCategory,
						action: this.trackAction,
						label: this.trackLabelSignedUpSM
					});
				}
			}).finally(() => {
				this.steps.current = this.steps.RELOADCOUNTER;
				this.formData.isLoading = false;
			});
		};

		this.createData = function () {
			var data = {};
			data.name = this.user.name;
			data.email = this.user.email;
			data.dayphone = this.user.phone;
			data.msg = this.user.message && this.user.message != 'Also add any questions or message' ? this.user.message : '';
			data.token = this.token;
			data.stepNum = this.steps.current;
			data.multisteps = this.isMultisteps;
			if (this.popup) {
				data.popup = this.popup;
			}
			if (this.popupName) {
				data.popupName = this.popupName;
			}
			if (this.source) {
				data.source = this.source;
			}
			if (this.version) {
				data.version = this.version;
			}
			if (this.user.listings) {
				data.listings = this.user.listings;
			}
			if (this.user.bedrooms) {
				data.bedrooms = this.user.bedrooms;
			}
			if (this.user.openhouse) {
				data.openhouse = this.user.openhouse;
			}
			if (this.headerVersion) {
				data.headerVersion = this.headerVersion;
			}
			if (this.collectionId) {
				data.collectionId = this.collectionId;
			}
			// keep only selected listings/buildings
			if (this.items && Object.entries(this.items).length > 0) {
				let listingsId = [];
				let buildingsId = [];
				Object.entries(this.items).forEach(entry => {
					entry[1].forEach(item => {
						if (item.selected) {
							if (item.listing_id) {
								listingsId.push(item.listing_id);
							} else if (item.building_id) {
								buildingsId.push(item.building_id);
							}
						}
					});
				});

				if (listingsId.length > 0) {
					data.listings = listingsId;
				} else if (buildingsId.length > 0) {
					data.buildings = buildingsId;
				}
			}

			if (this.user.buyerRenter) {
				let buyerRenter = 0;
				if (this.user.buyerRenter.buyer) {
					if (this.user.buyerRenter.renter) {
						buyerRenter = 3;
					} else {
						buyerRenter = 1;
					}
				} else if (this.user.buyerRenter.renter) {
					buyerRenter = 2;
				}
				data.buyerRenter = buyerRenter;
			}

			if (this.user.interestedInOffMarketListings) {
				data.interestedInOffMarketListings = this.user.interestedInOffMarketListings;
			}

			if (this.steps.current !== this.steps.MOREINFORMATION && (this.type === 'building-condo' || this.type === 'listing-sale' || this.position === 'topnav')) {
				if (this.user.visit && this.popup !== 'openhouse') {
					data.visit = this.user.visit;
				}

				if (this.startingDate && this.nbDays && this.popup !== 'openhouse') {
					if (this.user.selectedDate) {
						data.selectedDate = this.user.selectedDate.dateFormatted;
					} else {
						let dateSelected = this.formData.dates.find((d) => {
							return d.selected;
						});
						data.selectedDate = dateSelected.dateFormatted;
					}
				}
			}

			data.reCaptchaTokens = window.crRecaptcha.getTokens();

			return data;
		};

		this.closeTour = () => {
			ctrl.isClosing = false;
			PubSub.publish('cr-popup-close-' + this.popupName);
		};

		this.closeTheForm = () => {
			if (this.popupName) {
				this.closeTour();
			} else {
				this.reset();
			}

			this.onFormSubmitted();
		};

		this.closeTourListingPopup = () => {
			// close tour on listing popup (desktop)
			let popup = $element[0].closest('.w_popup');
			if (popup) {
				popup.classList.remove('_on_contact_form');
			}
		};

		this.yesEmailTheListings = () => {
			this.formData.isLoading = true;
			this.usrRegisterStatus = false;
			this.usrRegisterMessage = "";

			var input = {
				autoUsrToken: this.autoUsrToken
			};

			if (this.listingExtra) {
				let listingExtraParsed = angular.fromJson(this.listingExtra);
				input.listingToken = listingExtraParsed.listingToken;
			} else if (this.listingToken) {
				input.listingToken = this.listingToken;
			}

			if (this.buildingExtra) {
				let buildingExtraParsed = angular.fromJson(this.buildingExtra);
				input.buildingToken = buildingExtraParsed.buildingToken;
			} else if (this.buildingToken) {
				input.buildingToken = this.buildingToken;
			}

			// collection listings/buildings
			if (this.items && Object.entries(this.items).length > 0) {
				let listingsId = [];
				let buildingsId = [];
				Object.entries(this.items).forEach(entry => {
					entry[1].forEach(item => {
						if (item.selected) {
							if (item.listing_id) {
								listingsId.push(item.listing_id);
							} else if (item.building_id) {
								buildingsId.push(item.building_id);
							}
						}
					});
				});

				if (listingsId.length > 0) {
					input.listings = listingsId;
				} else if (buildingsId.length > 0) {
					input.buildings = buildingsId;
				}
			}


			var crDataPromise = crResourcesService.post(this.rpcRegisterContact, input);
			crDataPromise.then((data) => {
				if (typeof data.status !== "undefined") {
					this.usrRegisterStatus = data.status;
				}
				if (typeof data.message !== "undefined") {
					this.usrRegisterMessage = data.message;
				}
				if (this.trackLabelRegistered) {
					crTrackerQueue.track({
						category: this.trackCategory,
						action: this.trackAction,
						label: this.trackLabelRegistered
					});
				}
			}).finally(() => {
				this.steps.current = this.steps.RELOADCOUNTER;
				this.formData.isLoading = false;
			});
		};

		this.reset = () => {
			// reset success message
			this.hideSuccessMessage();

			// reset step
			if (this.mode === 'basic-question' || this.mode === 'basic-contact') {
				this.steps.current = this.steps.MOREINFORMATION;
			} else {
				this.steps.current = this.steps.STEP1;
			}

			// reset message
			if (this.user.message) {
				this.user.message = this.defaultMessage;
			}

			// reset visit
			if (this.user.visit) {
				this.user.visit = null;
			}

			// reset selected day
			if (this.user.selectedDate) {
				let defaultDate = moment(this.startingDate);

				this.formData.dates.forEach((d) => {
					d.selected = false;
				});
				this.formData.dates[0].selected = true;

				this.user.selectedDate = defaultDate;
			}
		};

		this.updatePopup = () => {
			PubSub.publish("cr-popup-update-success" + this.popupName, { isSuccessMessage: this.isSuccessMessage });
		};

		this.hideSuccessMessage = () => {
			this.successMessage = null;
			this.isSuccessMessage = false;

			this.updatePopup();
		};

		this.updateMsg = (data) => {
			this.user.message = (this.user.message ? this.user.message + ' ' : '') + data.buildingName;
		};

		if (this.popupName) {
			PubSub.subscribe('cr-popup-update-state-' + this.popupName, this.hideSuccessMessage);
		}
		PubSub.subscribe('cr-contact-buyers', this.updateMsg);
	}]
});